export default "__VITE_ASSET__LujFGGaH__"